import React from "react";
import {
  CalendarCheck,
  ProgressCheck,
  Receipt,
  CheckCircle,
  Send
} from "mdi-material-ui";
import {
  DialogFecha,
  DialogEstado,
  DialogFactura,
  DialogEnviarPremios
} from "./Dialogs";
import { USER_ROLES as Roles } from "js/models/User";
import { DialogAprobarVariablesMed } from "js/pages/Unilever/Dialogs";
export const toolbarMap = new Map([
  [
    "calendar",
    {
      key: "Fecha",
      actionIcon: <CalendarCheck color="primary" />,
      tooltip: "Cambiar fecha de entrega",
      component: DialogFecha,
      perms: [Roles.CANJE_W]
    }
  ],
  [
    "progress",
    {
      key: "Estado",
      actionIcon: <ProgressCheck color="primary" />,
      tooltip: "Cambiar estado",
      component: DialogEstado,
      perms: [Roles.CANJE_W]
    }
  ],
  [
    "asignar-factura",
    {
      text: "Asignar Factura",
      key: "asignarFactura",
      tooltip: "Asignar Factura",
      actionIcon: <Receipt color="primary" />,
      component: DialogFactura,
      perms: [Roles.FACTURA_W]
    }
  ],
  [
    "estado_variables_meds_unilever",
    {
      key: "Estado",
      actionIcon: <CheckCircle color="primary" />,
      tooltip: "Aprobar targets",
      component: DialogAprobarVariablesMed,
      perms: [Roles.MED_W]
    }
  ],
  [
    "enviar-premios",
    {
      text: "Enviar premios",
      key: "enviarPremios",
      tooltip: 'Envía premios de canjes en estado "a entregar"',
      actionIcon: <Send color="primary" />,
      component: DialogEnviarPremios,
      perms: [Roles.CANJE_W] //Analizar permiso necesario
    }
  ]
]);

export const getInitialValues = () => {
  const init = {};
  for (let [, value] of toolbarMap) {
    init[`dialog${value.key}`] = false;
  }
  return init;
};
